import React, { createContext, useContext, useState} from 'react';

const FilterContext = createContext();

export const FilterProvider = ({ children}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedFilter, setSelectedFilter] = useState("");

    return (
        <FilterContext.Provider value={{selectedFilter, setSelectedFilter, searchTerm, setSearchTerm}}>
            {children}
        </FilterContext.Provider>
    )
}

export const useFilterContext = () => useContext(FilterContext);
